import { sync } from "@/core/sync";
import { BINGO_EVENTS, makeEvent } from "@/core/sync/events";
import { useBingoGameStore } from "@/plugins/bingo/state/bingoGameStore";

/**
 * hostSyncBridge
 *
 * Runs in the Host window. Listens for STATE_REQUEST events from a
 * Projector that just opened, and replies with a full state snapshot so
 * the Projector can render the current game immediately.
 */

export function attachHostSyncBridge() {
  return sync.subscribe((event) => {
    if (!event || event.pluginId !== "bingo") return;
    if (event.type !== BINGO_EVENTS.STATE_REQUEST) return;

    const s = useBingoGameStore.getState();
    const snapshot = {
      sessionId: s.sessionId,
      status: s.status,
      stage: s.stage,
      drawIndex: s.drawIndex,
      called: s.called,
      undoDepth: s.undoDepth,
      manualMarks: s.manualMarks,
      mode: s.mode,
      autoInterval: s.autoInterval,
      winners: s.winners,
    };
    sync.publish(makeEvent(BINGO_EVENTS.STATE_SNAPSHOT, snapshot, "bingo"));
  });
}
